import CommonResponse from "../../models/CommonResponse";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function triggerRebootServer(client: BackendClient, reason: string): Promise<CommonResponse> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<CommonResponse>((resolve, reject) => {
      axios.post(`${client.getBackendUrl()}${BackendClient.TriggerRebootPath}`, {reason: reason}, {headers: headers})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when trying to trigger reboot: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }